import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'prism-accordion',
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.scss'
})
export class AccordionComponent {
  @Input() items: any[] = [];

  @Input() expandedIconClass: string = 'uil-angle-up';
  @Input() collapsedIconClass: string = 'uil-angle-down';
  @Input() iconSizeClass: string = 'text-3xl';

  @Input() showClickToExpandHint: boolean = false;
  @Input() clickToExpandText: string = '(Click to expand)';

  @ContentChild('accordionHeader', { read: TemplateRef }) headerTemplate?: TemplateRef<any>;
  @ContentChild('accordionBody', { read: TemplateRef }) bodyTemplate?: TemplateRef<any>;

  toggle(index: number): void {
    const item = this.items?.[index];
    if (!item) return;

    item.isActive = !item.isActive;
  }

  isActive(item: any): boolean {
    return !!item?.isActive;
  }

  getIconClass(item: any): string {
    const stateClass = this.isActive(item) ? this.expandedIconClass : this.collapsedIconClass;
    const sizeClass = this.iconSizeClass;
    return `${stateClass} ${sizeClass}`.trim();
  }
}
